import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/likeFilled.svg';

export const IconLikeFilled = createIconComponent(Icon);
